<template>
  <div>
    <Loading
      :active.sync="showOverlay"
      :is-full-page="true"
      :color="'#FFFFFF00'"
      :background-color="'#000000'"
      :opacity="1"
      :lock-scroll="true"
    />
    <div class="view-container">
      <PackageHeader
        :title="isEditMode ? 'PACKAGE EDITION' : 'NEW PACKAGE'"
        :saveAvailable="true"
        :cancel="cancelSavePackage"
        :save="savePackage"
      />
      <PackageBody />
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import PackageHeader from '@/components/forms/package/PackageHeader.vue';
import PackageBody from '@/components/forms/package/PackageBody.vue';

export default {
  name: 'FormPackage',
  components: {
    Loading,
    PackageHeader,
    PackageBody,
  },
  beforeRouteLeave: async function (to, from, next) {
    this.showOverlay = true
    await this.$store.dispatch('forms/setDefaultFormTab', 'packages')
    setTimeout(() => {
        this.$store.dispatch('common/hideNavbarAndHeader', false)
        this.$store.dispatch('common/setMainContainerWithFullWidth', false)
      }, 300)
    next();
  },
  data: function () {
    return {
      isDirty: false,
      showOverlay: false,
      packageId: this.$route.params.packageId,
    }
  },
  computed: {
    isEditMode() {
      return this.packageId ? true : false
    },
  },
  created: async function () { },
  methods: {
    async cancelSavePackage() {
      this.$router.push({ name: 'EditForm', params: { formID: this.$route.params.formID } })
    },
    savePackage() {
      // TODO : Implemente save logic
      alert("VIEW SAVE")

      this.$router.push({ name: 'EditForm', params: { formID: this.$route.params.formID } })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.view-container {
  max-height: 100svh;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100svh;
  margin: 0;
  overflow-y: auto;
  background-color: #F5F4F7;
}
</style>
